module.exports = __webpack_public_path__ + "static/avatar-8a14ec91baa0b542ac1af1bf13effed9.svg";